// ============================================
// PAGE - Register Success
// ============================================

import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@almacenes/ui';

export const RegisterSuccessPage = () => {
  // Google Ads Conversion Tracking - Se ejecuta solo en esta página
  useEffect(() => {
    if (typeof window.gtag !== 'undefined') {
      window.gtag('event', 'conversion', {
        'send_to': 'AW-7931958227/m1lLCNWz8fIbENPvz-ZC'
      });
    }
  }, []);

  return (
    <div 
      className="min-h-screen h-screen flex flex-col items-center justify-center p-6 relative overflow-hidden"
      style={{ 
        background: 'linear-gradient(180deg, #059669 0%, #047857 100%)'
      }}
    >
      {/* Efectos decorativos de fondo */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div 
          className="absolute top-0 right-0 w-1/2 h-1/2 rounded-full blur-3xl opacity-10"
          style={{ 
            background: '#10B981'
          }}
        />
        <div 
          className="absolute bottom-0 left-0 w-1/2 h-1/2 rounded-full blur-3xl opacity-10"
          style={{ 
            background: '#34D399'
          }}
        />
      </div>
      {/* Logo en la parte superior */}
      <div className="absolute top-8 left-8 z-10">
        <h2 className="text-2xl font-bold flex items-baseline">
          <span className="text-[#43BFFF]">ALMACENES</span>
          {' '}
          <span className="text-yellow-400 text-xl font-normal">digitales</span>
        </h2>
      </div>

      {/* Contenido principal centrado */}
      <div className="max-w-2xl w-full text-center relative z-10">
        {/* Icono de éxito grande */}
        <div className="flex justify-center mb-8">
          <div className="w-32 h-32 rounded-full bg-white shadow-2xl flex items-center justify-center">
            <svg 
              className="w-20 h-20 text-green-600" 
              fill="none" 
              stroke="currentColor" 
              viewBox="0 0 24 24"
            >
              <path 
                strokeLinecap="round" 
                strokeLinejoin="round" 
                strokeWidth={2.5} 
                d="M5 13l4 4L19 7" 
              />
            </svg>
          </div>
        </div>

        {/* Título grande */}
        <h1 className="text-5xl lg:text-6xl font-bold text-white mb-6">
          ¡Registro exitoso!
        </h1>

        {/* Mensaje principal */}
        <div className="mb-10">
          <p className="text-xl lg:text-2xl text-white mb-4 leading-relaxed">
            Hemos enviado un correo electrónico a tu dirección para que puedas verificar tu cuenta y completar el proceso de registro.
          </p>
          <p className="text-lg lg:text-xl text-white/90 leading-relaxed">
            Revisa tu bandeja de entrada y sigue las instrucciones para activar tu cuenta.
          </p>
        </div>

        {/* Información adicional */}
        <div className="bg-white/80 backdrop-blur-sm rounded-2xl p-6 mb-10 shadow-lg">
          <div className="flex items-start justify-center text-left">
            <svg 
              className="w-6 h-6 text-blue-600 mr-3 mt-1 flex-shrink-0" 
              fill="currentColor" 
              viewBox="0 0 20 20"
            >
              <path 
                fillRule="evenodd" 
                d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" 
                clipRule="evenodd" 
              />
            </svg>
            <div className="text-gray-800">
              <p className="font-semibold text-lg mb-2">¿No recibes el correo?</p>
              <p className="text-base">Revisa tu carpeta de spam o correo no deseado. Si aún no lo encuentras, puedes solicitar un nuevo correo de verificación.</p>
            </div>
          </div>
        </div>

        {/* Botones de acción */}
        <div className="space-y-4">
          <Link to="/auth/login" className="block">
            <Button
              variant="primary"
              className="w-full max-w-md mx-auto shadow-lg"
              size="lg"
            >
              Ir a iniciar sesión
            </Button>
          </Link>
          
          <div className="text-center">
            <Link 
              to="/auth/register" 
              className="text-white font-semibold text-base hover:text-white/80 underline"
            >
              Volver al registro
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};
